import { ILanguage } from '../interfaces/globalization.interfaces';

/**
 * Get the isoCode based on id
 * This method is a temporary helper until the application language is only using isoCodes
 * @param languages
 * @param id
 * @returns
 */
export const idToIso = (languages: ILanguage[], id: number): string => {
    return languages.find((lang) => lang.id === id)?.isoCode || 'da';
};

/**
 * Get the language id based on isoCode
 * This method is a temporary helper until the application language is only using isoCodes
 * @param languages
 * @param isoCode
 * @returns
 */
export const isoToId = (languages: ILanguage[], isoCode: string): number => {
    return languages.find((lang) => lang.isoCode === isoCode)?.id || 2;
};
